import React, { FC } from "react";

const AMOUNT_PLACEHOLDER = "---";

interface Props {
  amount: number | null;
}

export const TotalAmountBlock: FC<Props> = ({ amount }) => {
  const totalAmount = amount ? amount : AMOUNT_PLACEHOLDER;

  return (
    <div className="flex flex-col items-start gap-5 justify-between p-5 bg-green-light text-green-base rounded-2xl md:flex-row md:items-center md:p-10 lg:p-15">
      <div className="flex flex-col gap-5 lg:gap-7">
        <h3 className="text-lg font-black leading-none md:text-28 lg:text-48">
          Загальна сума
        </h3>
        <p className="text-sm md:text-base">* приблизна вартість послуги</p>
      </div>
      <div>
        <h2 className="text-24 font-black leading-none md:text-32 lg:text-64">
          від {totalAmount} грн*
        </h2>
      </div>
    </div>
  );
};
